import React, { FunctionComponent } from 'react';
import { Link } from 'gatsby';
import { formatArticleLink } from '../../utils/formatLink';
import { ArticlePreview } from '../../types/articlePreview';
import { formatDate } from '../../utils/formatDate';
import { InternalLinkIcon } from '../Icons';
import './styles.scss';

type ArticleCardProps = {
  article: ArticlePreview;
}

const ArticleCard: FunctionComponent<ArticleCardProps> = ({ article }) => {
  return (
    <Link
      to={formatArticleLink(article)}
      className='article-card'
    >
      <div>
        <strong>{article.teaser?.title ? article.teaser.title : article.title}</strong>
        {/* <span>{formatDate(article._createdAt)}</span> */}
      </div>
      <InternalLinkIcon />
    </Link>
  );
}

export default ArticleCard;
